import { setUSER } from "../constants/user.types";

export const setUser = (userName: string) => {
  return {
    type: setUSER,
    payload: userName,
  };
};
